/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ApprovalRequestEmail {
    SendToUsersManager = 0,
    SendToSystemAdministrator = 1,
    SendToSpecificEmailAddress = 2,
    DontSend = 3,
}
